import { useMutation } from '@tanstack/react-query';
import { createLifeArea } from 'shared/services/backend-api';
import { NewLifeArea } from 'shared/types/life-area';

export const useCreateLifeAreaMutation = () =>
  useMutation({
    mutationFn: async (lifeArea: NewLifeArea) => createLifeArea(lifeArea),
  });
